import React from 'react';
import CreatePostContent from './content';
import CreatePostProvider from 'contexts/create-post.context/provider';

const CreatePostLayout = () => {
  return (
    <CreatePostProvider>
      <CreatePostContent />
    </CreatePostProvider>
  );
};

export default CreatePostLayout;
